import React from 'react';
import styled from 'styled-components';
import * as color from '@constant/color';
import * as size from '@constant/size';
import TextBlock from '@component/common/block/text-block';
import { actions as modalActions } from '@store/slice/modal-slice';
import { useTypedDispatch } from '@hook/common/useStore';
import { useAuthPage } from '@hook/auth/useAuth';
import { INeedSigninModalData } from '@datatype/iyagigo/type';

interface IProps {
  data: INeedSigninModalData['data'];
}

const Wrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  width: ${size.MEDIUM_MODAL_WIDTH};
`;

const DIALOG_TEXT_DESIGN = {
  text: { size: 'medium', color: color.BLACK_2, bold: false },
} as const;

const GO_SIGNIN_TEXT_DESIGN = {
  text: { size: 'medium', color: color.BROWN_1, bold: false, underline: true },
  box: { margin: `${size.MARGIN_1} 0px 0px 0px`, event: { cursor: 'pointer' } },
} as const;

const NeedSigninModal: React.FC<IProps> = ({ data }) => {
  const dispatch = useTypedDispatch();
  const { openAuthPage } = useAuthPage();

  const handleGoSigninClick = () => {
    dispatch(modalActions.hideModal());
    openAuthPage('signin');
  };

  return (
    <Wrapper>
      <TextBlock text={data} design={DIALOG_TEXT_DESIGN} />
      <TextBlock text={'로그인 하러가기'} design={GO_SIGNIN_TEXT_DESIGN} click={{ handler: handleGoSigninClick }} />
    </Wrapper>
  );
};

export default NeedSigninModal;
